import { useTranslate } from "ui/locale";
import { ScanModalTab } from "../ScanModal.types";
import ReceiveTab from "../ReceiveTab/ReceiveTab";
import SendDetailsForm from "../../SendDetailsForm/SendDetailsForm";

export const TX_MODAL_TABS: ScanModalTab[] = [
    {
        label: "send",
        children: <SendDetailsForm />,
        path: "send",
    },
    {
        label: "receive",
        children: <ReceiveTab />,
        path: "receive",
    },
];

export default function useScanModalTabs() {
    const translate = useTranslate();
    return TX_MODAL_TABS.map((tab) => ({
        ...tab,
        label: translate(tab.label),
    }));
}
